import { useState, useEffect } from 'react';
import { StarIcon } from '@heroicons/react/20/solid';
import { StarIcon as StarOutlineIcon } from '@heroicons/react/24/outline';
import { apiGetCustomerOrderFeedbackByOrder } from '../../../../services/FeedbackApi';

const Rating = ({ order }) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [, setExistingFeedback] = useState(null);

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const response = await apiGetCustomerOrderFeedbackByOrder(order.id);

        if (response?.data) {
          setExistingFeedback(response.data.feedbackText);
          setRating(response.data.starCount || 0);
          setFeedback(response.data.feedbackText || '');
        }
      } catch (error) {
        console.error('Error fetching feedback:', error);
      }
    };

    if (order.id) {
      fetchFeedback();
    }
  }, [order.id]);

  const getRatingText = (rating) => {
    switch (rating) {
      case 1:
        return 'Poor';
      case 2:
        return 'Fair';
      case 3:
        return 'Good';
      case 4:
        return 'Very Good';
      case 5:
        return 'Excellent';
      default:
        return '';
    }
  };

  if (!rating) return null;

  return (
    <div className="mt-6 p-6 bg-slate-50 rounded-md shadow-md">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-semibold text-lg">Order Rating</h2>
        <span className="text-sm font-medium text-slate-600">
          {getRatingText(rating)}
        </span>
      </div>
      <div className="flex items-center mb-4">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          return starValue <= rating ? (
            <StarIcon key={index} className="w-7 h-7 mr-2 text-yellow-400" />
          ) : (
            <StarOutlineIcon
              key={index}
              className="w-7 h-7 mr-2 text-gray-300"
            />
          );
        })}
      </div>
      {feedback && (
        <div className="bg-white p-4 rounded-md border border-slate-200">
          <p className="text-slate-700 text-sm leading-relaxed">{feedback}</p>
        </div>
      )}
    </div>
  );
};

export default Rating;
